"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueprintRunnerServiceServer = exports.BlueprintRunnerServiceDispatcher = exports.BlueprintRunnerServiceClient = void 0;
var BlueprintRunSubscriptions_1 = require("./BlueprintRunSubscriptions");
var services_shared_1 = require("@playq/services-shared");
var services_flower_1 = require("@playq/services-flower");
var BlueprintEntityID_1 = require("./BlueprintEntityID");
var irt_1 = require("@playq/irt");
var InRun = (function () {
    function InRun(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new BlueprintEntityID_1.BlueprintEntityID(data.id);
        this.runConfig = new services_flower_1.BlueprintRunConfig(data.runConfig);
        this.runContext = new services_flower_1.BlueprintRunContext(data.runContext);
    }
    Object.defineProperty(InRun.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRun.prototype, "runConfig", {
        get: function () {
            return this._runConfig;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field runConfig is not optional');
            }
            this._runConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRun.prototype, "runContext", {
        get: function () {
            return this._runContext;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field runContext is not optional');
            }
            this._runContext = value;
        },
        enumerable: false,
        configurable: true
    });
    InRun.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            runConfig: this.runConfig.serialize(),
            runContext: this.runContext.serialize()
        };
    };
    return InRun;
}());
var OutRunHelpers = (function () {
    function OutRunHelpers() {
    }
    OutRunHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRunHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_flower_1.BlueprintRun(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRunHelpers;
}());
var InAbort = (function () {
    function InAbort(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_flower_1.BlueprintRunId(data.id);
    }
    Object.defineProperty(InAbort.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InAbort.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InAbort;
}());
var OutAbortHelpers = (function () {
    function OutAbortHelpers() {
    }
    OutAbortHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutAbortHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutAbortHelpers;
}());
var InStatus = (function () {
    function InStatus(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_flower_1.BlueprintRunId(data.id);
    }
    Object.defineProperty(InStatus.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InStatus.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InStatus;
}());
var OutStatusHelpers = (function () {
    function OutStatusHelpers() {
    }
    OutStatusHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutStatusHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_flower_1.BlueprintRun(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutStatusHelpers;
}());
var InStatusWithDebug = (function () {
    function InStatusWithDebug(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_flower_1.BlueprintRunId(data.id);
    }
    Object.defineProperty(InStatusWithDebug.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InStatusWithDebug.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InStatusWithDebug;
}());
var OutStatusWithDebugHelpers = (function () {
    function OutStatusWithDebugHelpers() {
    }
    OutStatusWithDebugHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutStatusWithDebugHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_flower_1.BlueprintRunWithDebug(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutStatusWithDebugHelpers;
}());
var InRetrieveStreamTail = (function () {
    function InRetrieveStreamTail(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_flower_1.BlueprintRunId(data.id);
        this.ref = new services_flower_1.StreamValRef(data.ref);
    }
    Object.defineProperty(InRetrieveStreamTail.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRetrieveStreamTail.prototype, "ref", {
        get: function () {
            return this._ref;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ref is not optional');
            }
            this._ref = value;
        },
        enumerable: false,
        configurable: true
    });
    InRetrieveStreamTail.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            ref: this.ref.serialize()
        };
    };
    return InRetrieveStreamTail;
}());
var OutRetrieveStreamTailHelpers = (function () {
    function OutRetrieveStreamTailHelpers() {
    }
    OutRetrieveStreamTailHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveStreamTailHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_flower_1.BlueprintRunStreamTail(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveStreamTailHelpers;
}());
var InEnumerate = (function () {
    function InEnumerate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new BlueprintEntityID_1.BlueprintEntityID(data.id);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
    }
    Object.defineProperty(InEnumerate.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InEnumerate.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    InEnumerate.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            iterator: this.iterator.serialize()
        };
    };
    return InEnumerate;
}());
var OutEnumerateHelpers = (function () {
    function OutEnumerateHelpers() {
    }
    OutEnumerateHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutEnumerateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_flower_1.BlueprintRuns(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutEnumerateHelpers;
}());
var InSubscribeForUpdates = (function () {
    function InSubscribeForUpdates(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_flower_1.BlueprintRunId(data.id);
    }
    Object.defineProperty(InSubscribeForUpdates.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InSubscribeForUpdates.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InSubscribeForUpdates;
}());
var OutSubscribeForUpdatesHelpers = (function () {
    function OutSubscribeForUpdatesHelpers() {
    }
    OutSubscribeForUpdatesHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutSubscribeForUpdatesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSubscribeForUpdatesHelpers;
}());
var InUnsubscribe = (function () {
    function InUnsubscribe(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_flower_1.BlueprintRunId(data.id);
    }
    Object.defineProperty(InUnsubscribe.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InUnsubscribe.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InUnsubscribe;
}());
var OutUnsubscribeHelpers = (function () {
    function OutUnsubscribeHelpers() {
    }
    OutUnsubscribeHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUnsubscribeHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUnsubscribeHelpers;
}());
var InListSubscriptions = (function () {
    function InListSubscriptions(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InListSubscriptions.prototype.serialize = function () {
        return {};
    };
    return InListSubscriptions;
}());
var OutListSubscriptionsHelpers = (function () {
    function OutListSubscriptionsHelpers() {
    }
    OutListSubscriptionsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutListSubscriptionsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new BlueprintRunSubscriptions_1.BlueprintRunSubscriptions(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutListSubscriptionsHelpers;
}());
var InRetrieveDataSample = (function () {
    function InRetrieveDataSample(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.op = new services_flower_1.OpStreamFromDataset(data.op);
        this.sampleSize = data.sampleSize;
    }
    Object.defineProperty(InRetrieveDataSample.prototype, "op", {
        get: function () {
            return this._op;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field op is not optional');
            }
            this._op = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRetrieveDataSample.prototype, "sampleSize", {
        get: function () {
            return this._sampleSize;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sampleSize is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field sampleSize expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field sampleSize is expected to be an integer, got ' + value);
            }
            this._sampleSize = value;
        },
        enumerable: false,
        configurable: true
    });
    InRetrieveDataSample.prototype.serialize = function () {
        return {
            op: this.op.serialize(),
            sampleSize: this.sampleSize
        };
    };
    return InRetrieveDataSample;
}());
var OutRetrieveDataSampleHelpers = (function () {
    function OutRetrieveDataSampleHelpers() {
    }
    OutRetrieveDataSampleHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveDataSampleHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_flower_1.DatasetSample(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveDataSampleHelpers;
}());
var InExtractDataSchema = (function () {
    function InExtractDataSchema(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.source = services_flower_1.DatasetSourceHelpers.deserialize(data.source);
        this.format = services_flower_1.DatasetFormat[data.format];
        this.dataSampleSize = typeof data.dataSampleSize !== 'undefined' ? new services_flower_1.DataSampleSize(data.dataSampleSize) : undefined;
    }
    Object.defineProperty(InExtractDataSchema.prototype, "source", {
        get: function () {
            return this._source;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field source is not optional');
            }
            this._source = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InExtractDataSchema.prototype, "format", {
        get: function () {
            return this._format;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field format is not optional');
            }
            this._format = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InExtractDataSchema.prototype, "dataSampleSize", {
        get: function () {
            return this._dataSampleSize;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._dataSampleSize = undefined;
                return;
            }
            this._dataSampleSize = value;
        },
        enumerable: false,
        configurable: true
    });
    InExtractDataSchema.prototype.serialize = function () {
        return {
            source: services_flower_1.DatasetSourceHelpers.serialize(this.source),
            format: services_flower_1.DatasetFormat[this.format],
            dataSampleSize: typeof this.dataSampleSize !== 'undefined' ? this.dataSampleSize.serialize() : undefined
        };
    };
    return InExtractDataSchema;
}());
var OutExtractDataSchemaHelpers = (function () {
    function OutExtractDataSchemaHelpers() {
    }
    OutExtractDataSchemaHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': typeof either.value !== 'undefined' ? either.value.serialize() : undefined
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutExtractDataSchemaHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(typeof content !== 'undefined' ? new services_flower_1.ReadIntoStruct(content) : undefined);
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutExtractDataSchemaHelpers;
}());
var InRetrieveVortexSchema = (function () {
    function InRetrieveVortexSchema(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InRetrieveVortexSchema.prototype.serialize = function () {
        return {};
    };
    return InRetrieveVortexSchema;
}());
var OutRetrieveVortexSchemaHelpers = (function () {
    function OutRetrieveVortexSchemaHelpers() {
    }
    OutRetrieveVortexSchemaHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveVortexSchemaHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_flower_1.VortexEventSchema(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveVortexSchemaHelpers;
}());
var BlueprintRunnerServiceClient = (function () {
    function BlueprintRunnerServiceClient(transport) {
        this._transport = transport;
    }
    BlueprintRunnerServiceClient.prototype.getPackageName = function () { return BlueprintRunnerServiceClient.PackageName; };
    BlueprintRunnerServiceClient.prototype.getClassName = function () { return BlueprintRunnerServiceClient.ClassName; };
    BlueprintRunnerServiceClient.prototype.getFullClassName = function () { return BlueprintRunnerServiceClient.FullClassName; };
    BlueprintRunnerServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.run = function (id, runConfig, runContext) {
        var _this = this;
        var __data = new InRun();
        __data.id = id;
        __data.runConfig = runConfig;
        __data.runContext = runContext;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'run', __data)
                .then(function (data) {
                try {
                    resolve(OutRunHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.abort = function (id) {
        var _this = this;
        var __data = new InAbort();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'abort', __data)
                .then(function (data) {
                try {
                    resolve(OutAbortHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.status = function (id) {
        var _this = this;
        var __data = new InStatus();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'status', __data)
                .then(function (data) {
                try {
                    resolve(OutStatusHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.statusWithDebug = function (id) {
        var _this = this;
        var __data = new InStatusWithDebug();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'statusWithDebug', __data)
                .then(function (data) {
                try {
                    resolve(OutStatusWithDebugHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.retrieveStreamTail = function (id, ref) {
        var _this = this;
        var __data = new InRetrieveStreamTail();
        __data.id = id;
        __data.ref = ref;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'retrieveStreamTail', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveStreamTailHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.enumerate = function (id, iterator) {
        var _this = this;
        var __data = new InEnumerate();
        __data.id = id;
        __data.iterator = iterator;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'enumerate', __data)
                .then(function (data) {
                try {
                    resolve(OutEnumerateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.subscribeForUpdates = function (id) {
        var _this = this;
        var __data = new InSubscribeForUpdates();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'subscribeForUpdates', __data)
                .then(function (data) {
                try {
                    resolve(OutSubscribeForUpdatesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.unsubscribe = function (id) {
        var _this = this;
        var __data = new InUnsubscribe();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'unsubscribe', __data)
                .then(function (data) {
                try {
                    resolve(OutUnsubscribeHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.listSubscriptions = function () {
        var _this = this;
        var __data = new InListSubscriptions();
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'listSubscriptions', __data)
                .then(function (data) {
                try {
                    resolve(OutListSubscriptionsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.retrieveDataSample = function (op, sampleSize) {
        var _this = this;
        var __data = new InRetrieveDataSample();
        __data.op = op;
        __data.sampleSize = sampleSize;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'retrieveDataSample', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveDataSampleHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.extractDataSchema = function (source, format, dataSampleSize) {
        var _this = this;
        var __data = new InExtractDataSchema();
        __data.source = source;
        __data.format = format;
        __data.dataSampleSize = dataSampleSize;
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'extractDataSchema', __data)
                .then(function (data) {
                try {
                    resolve(OutExtractDataSchemaHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.prototype.retrieveVortexSchema = function () {
        var _this = this;
        var __data = new InRetrieveVortexSchema();
        return new Promise(function (resolve, reject) {
            _this._transport.send(BlueprintRunnerServiceClient.ClassName, 'retrieveVortexSchema', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveVortexSchemaHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    BlueprintRunnerServiceClient.PackageName = 'net.playq.octopus2.analytics';
    BlueprintRunnerServiceClient.ClassName = 'BlueprintRunnerService';
    BlueprintRunnerServiceClient.FullClassName = 'net.playq.octopus2.analytics.BlueprintRunnerService';
    return BlueprintRunnerServiceClient;
}());
exports.BlueprintRunnerServiceClient = BlueprintRunnerServiceClient;
var BlueprintRunnerServiceDispatcher = (function () {
    function BlueprintRunnerServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    BlueprintRunnerServiceDispatcher.prototype.getSupportedService = function () {
        return 'BlueprintRunnerService';
    };
    BlueprintRunnerServiceDispatcher.prototype.getSupportedMethods = function () {
        return BlueprintRunnerServiceDispatcher.methods;
    };
    BlueprintRunnerServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "run": {
                var obj_1 = new InRun(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.run(context, obj_1.id, obj_1.runConfig, obj_1.runContext)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRunHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "abort": {
                var obj_2 = new InAbort(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.abort(context, obj_2.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutAbortHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "status": {
                var obj_3 = new InStatus(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.status(context, obj_3.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutStatusHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "statusWithDebug": {
                var obj_4 = new InStatusWithDebug(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.statusWithDebug(context, obj_4.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutStatusWithDebugHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieveStreamTail": {
                var obj_5 = new InRetrieveStreamTail(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieveStreamTail(context, obj_5.id, obj_5.ref)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveStreamTailHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "enumerate": {
                var obj_6 = new InEnumerate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.enumerate(context, obj_6.id, obj_6.iterator)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutEnumerateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "subscribeForUpdates": {
                var obj_7 = new InSubscribeForUpdates(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.subscribeForUpdates(context, obj_7.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSubscribeForUpdatesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "unsubscribe": {
                var obj_8 = new InUnsubscribe(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.unsubscribe(context, obj_8.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUnsubscribeHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "listSubscriptions": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.listSubscriptions(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutListSubscriptionsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieveDataSample": {
                var obj_9 = new InRetrieveDataSample(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieveDataSample(context, obj_9.op, obj_9.sampleSize)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveDataSampleHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "extractDataSchema": {
                var obj_10 = new InExtractDataSchema(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.extractDataSchema(context, obj_10.source, obj_10.format, obj_10.dataSampleSize)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutExtractDataSchemaHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieveVortexSchema": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieveVortexSchema(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveVortexSchemaHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by BlueprintRunnerServiceDispatcher."));
        }
    };
    BlueprintRunnerServiceDispatcher.methods = [
        "run",
        "abort",
        "status",
        "statusWithDebug",
        "retrieveStreamTail",
        "enumerate",
        "subscribeForUpdates",
        "unsubscribe",
        "listSubscriptions",
        "retrieveDataSample",
        "extractDataSchema",
        "retrieveVortexSchema"
    ];
    return BlueprintRunnerServiceDispatcher;
}());
exports.BlueprintRunnerServiceDispatcher = BlueprintRunnerServiceDispatcher;
var BlueprintRunnerServiceServer = (function (_super) {
    __extends(BlueprintRunnerServiceServer, _super);
    function BlueprintRunnerServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    BlueprintRunnerServiceServer.prototype.run = function (context, id, runConfig, runContext) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.abort = function (context, id) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.status = function (context, id) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.statusWithDebug = function (context, id) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.retrieveStreamTail = function (context, id, ref) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.enumerate = function (context, id, iterator) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.subscribeForUpdates = function (context, id) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.unsubscribe = function (context, id) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.listSubscriptions = function (context) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.retrieveDataSample = function (context, op, sampleSize) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.extractDataSchema = function (context, source, format, dataSampleSize) {
        throw new Error('Not implemented.');
    };
    BlueprintRunnerServiceServer.prototype.retrieveVortexSchema = function (context) {
        throw new Error('Not implemented.');
    };
    return BlueprintRunnerServiceServer;
}(BlueprintRunnerServiceDispatcher));
exports.BlueprintRunnerServiceServer = BlueprintRunnerServiceServer;
//# sourceMappingURL=BlueprintRunnerService.js.map